import { render, staticRenderFns } from "./VipCard.vue?vue&type=template&id=d3cd8da6&scoped=true&"
import script from "./VipCard.vue?vue&type=script&lang=js&"
export * from "./VipCard.vue?vue&type=script&lang=js&"
import style0 from "./VipCard.vue?vue&type=style&index=0&id=d3cd8da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cd8da6",
  null
  
)

export default component.exports